import React from 'react';

import Account from '~/assets/icons/account.svg?react';
import Arrow from '~/assets/icons/arrow.svg?react';
import Chevron from '~/assets/icons/chevron.svg?react';
import Calendar from '~/assets/icons/calendar.svg?react';
import Check from '~/assets/icons/check.svg?react';
import Checkmark from '~/assets/icons/checkmark.svg?react';
import Close from '~/assets/icons/close.svg?react';
import Copy from '~/assets/icons/copy.svg?react';
import Cross from '~/assets/icons/cross.svg?react';
import Crossword from '~/assets/icons/crossword.svg?react';
import Cursor from '~/assets/icons/cursor.svg?react';
import Discord from '~/assets/icons/discord.svg?react';
import Flame from '~/assets/icons/flame.svg?react';
import Gear from '~/assets/icons/gear.svg?react';
import HandStar from '~/assets/icons/hand-star.svg?react';
import Image from '~/assets/icons/image.svg?react';
import Info from '~/assets/icons/info.svg?react';
import Instagram from '~/assets/icons/instagram.svg?react';
import Map from '~/assets/icons/map.svg?react';
import Multiplayer from '~/assets/icons/multiplayer.svg?react';
import Panorama from '~/assets/icons/panorama.svg?react';
import Pause from '~/assets/icons/pause.svg?react';
import Pin from '~/assets/icons/pin.svg?react';
import Play from '~/assets/icons/play.svg?react';
import PrivacyPolicy from '~/assets/icons/privacy-policy.svg?react';
import Question from '~/assets/icons/question.svg?react';
import Refresh from '~/assets/icons/refresh.svg?react';
import Remove from '~/assets/icons/remove.svg?react';
import Scoreboard from '~/assets/icons/scoreboard.svg?react';
import Singleplayer from '~/assets/icons/singleplayer.svg?react';
import Skull from '~/assets/icons/skull.svg?react';
import Smiley from '~/assets/icons/smiley.svg?react';
import Sound from '~/assets/icons/sound.svg?react';
import Star from '~/assets/icons/star.svg?react';
import ThumbsDown from '~/assets/icons/thumbs-down.svg?react';
import TikTok from '~/assets/icons/tiktok.svg?react';
import Video from '~/assets/icons/video.svg?react';
import Expand from '~/assets/icons/expand.svg?react';
import Model from '~/assets/icons/model.svg?react';
import Spotlight from '~/assets/icons/spotlights.svg?react';
import Download from '~/assets/icons/download.svg?react';
import Clock from '~/assets/icons/clock.svg?react';
import YouTube from '~/assets/icons/youtube.svg?react';
import Kofi from '~/assets/icons/kofi.svg?react';

import { cn } from '~/utils/cn';

export type SVGProps = React.SVGProps<SVGSVGElement>;

const icons = {
  account: Account,
  arrow: Arrow,
  chevron: Chevron,
  calendar: Calendar,
  check: Check,
  checkmark: Checkmark,
  copy: Copy,
  close: Close,
  cross: Cross,
  crossword: Crossword,
  cursor: Cursor,
  discord: Discord,
  flame: Flame,
  gear: Gear,
  handStar: HandStar,
  image: Image,
  info: Info,
  instagram: Instagram,
  map: Map,
  multiplayer: Multiplayer,
  panorama: Panorama,
  pause: Pause,
  pin: Pin,
  play: Play,
  privacyPolicy: PrivacyPolicy,
  question: Question,
  refresh: Refresh,
  remove: Remove,
  scoreboard: Scoreboard,
  singleplayer: Singleplayer,
  skull: Skull,
  smiley: Smiley,
  sound: Sound,
  star: Star,
  thumbsDown: ThumbsDown,
  tiktok: TikTok,
  kofi: Kofi,
  video: Video,
  model: Model,
  expand: Expand,
  spotlight: Spotlight,
  download: Download,
  clock: Clock,
  youtube: YouTube
} as const;

export type IconName = keyof typeof icons;

export type IconProps = {
  name: IconName;
  size?: number;
  className?: string;
  bigShadow?: boolean;
} & SVGProps;

function Icon({ name, size = 6, ...props }: IconProps) {
  const RequestedIcon = icons[name] ?? Image;
  const sizeClass = `size-${size}`;

  return (
    <RequestedIcon {...props} className={cn(sizeClass, props.className)} />
  );
}

export default Icon;
